import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../../../infra/ui/button';
import { useToggle } from '../../../../infra/small-tools/use-toggle';
import { CustomAcceptWalkInClient } from '../accept-walk-in-client';
var AcceptUserContainer = function (_a) {
    var walkInItem = _a.walkInItem;
    var acceptUserModal = useToggle();
    return (_jsxs(_Fragment, { children: [_jsx(Button.Light, { fullWidth: true, onClick: acceptUserModal.setOn, children: "Accept" }), acceptUserModal.isOn && _jsx(CustomAcceptWalkInClient, { onClose: acceptUserModal.setOff, walkInItem: walkInItem })] }));
};
export var AcceptUserAction = AcceptUserContainer;
